import { useEffect, useRef } from 'react';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { globalQueryClient, queryClient } from 'root/src/client/v2/common/clients/queryClient';
// On the logged-out -> logged-in transition (or an account switch), invalidate every React Query cache
// so all data refetches under the new identity. The redesign sign-in is a SPA action (the dialog calls
// `onSignIn` and closes; it does NOT navigate), so without this the navbar and any queries fetched while
// logged out (or as a previous user) stay stale until a manual reload - the query clients use
// `refetchOnMount: false` and a long `staleTime`. Both providers are invalidated: `globalQueryClient`
// (useUserData / useApplicationState) and `queryClient` (tRPC + general react-query). Logout already
// does a full navigation, so it needs no equivalent.
export const useResetQueriesOnLogin = () => {
    const { authentication } = useAuthentication();
    const userId = authentication === null || authentication === void 0 ? void 0 : authentication.userId;
    const previousUserId = useRef(userId);
    useEffect(() => {
        // Fires on login (undefined -> id) and account switch (idA -> idB), not on logout (id -> undefined).
        if (userId && userId !== previousUserId.current) {
            void queryClient.invalidateQueries();
            void globalQueryClient.invalidateQueries();
        }
        previousUserId.current = userId;
    }, [userId]);
};
